import React, { useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../agenticsaas/contexts/AuthContext';
import { useEffectiveAccess } from '../agenticsaas/contexts/EffectiveAccessContext';
import {
  DASHBOARD_VIEWS,
  getDashboardRoutes,
  getStoredDashboardPreference,
  resolveDashboardView,
} from '../utils/dashboardPreferences';
import ExecutiveDashboard from './dashboard/ExecutiveDashboard';
import OperationalDashboard from './dashboard/OperationalDashboard';
import FinanceDashboard from './dashboard/FinanceDashboard';

/**
 * Landing route: sends users to executive, operational, or finance dashboard based on
 * role + Settings preference (auto | executive | operational | finance).
 */
export default function LandingDashboard() {
  const { user, initialized, loading } = useAuthContext();
  const { role, loading: accessLoading } = useEffectiveAccess();
  const location = useLocation();
  const routes = getDashboardRoutes();
  const preference = getStoredDashboardPreference();

  const targetView = useMemo(
    () => resolveDashboardView(user, preference, { orgRole: role }),
    [user, preference, role]
  );

  useEffect(() => {
    if (location.pathname === '/' && initialized && !loading && !accessLoading) {
      console.log('[LandingDashboard] resolved view:', targetView, 'preference:', preference, 'role:', role);
    }
  }, [location.pathname, initialized, loading, accessLoading, targetView, preference, role]);

  if (!initialized || loading || accessLoading) {
    return (
      <div className="py-12 flex justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (location.pathname === '/' || location.pathname === '/dashboard') {
    const dest =
      targetView === DASHBOARD_VIEWS.FINANCE
        ? routes.finance
        : targetView === DASHBOARD_VIEWS.EXECUTIVE
          ? routes.executive
          : routes.operational;
    return <Navigate to={dest} replace />;
  }

  return null;
}

export function ExecutiveDashboardPage() {
  return <ExecutiveDashboard />;
}

export function OperationalDashboardPage() {
  return <OperationalDashboard />;
}

export function FinanceDashboardPage() {
  return <FinanceDashboard />;
}
